import request from '@/utils/request';
export const defaultBranchData = {
  id: 0,
  enabled: true,
  name: '',
  mobileNumber: null,
  tallyParentName: null,
  tallyAlias: null,
  code: '',
  gstNumber: null,
  panNumber: null,
  line1: null,
  line2: null,
  pincodeId: null,
  isEditable: true,
  equivalentDealerId: null,
  pincode: {
    id: null
  },
  cityId: undefined,
  city: {
    id: undefined
  },
  stateId: undefined,
  state: {
    id: undefined
  },
  countryId: undefined,
  country: {
    id: undefined
  }
};
export const getBranches = params => request({
  url: '/branches',
  method: 'get',
  params
});
export const getBranchById = id => request({
  url: `/branches/${id}`,
  method: 'get'
});
export const updateBranch = (id, data) => request({
  url: `/branches/${id}`,
  method: 'patch',
  data
});
export const deleteBranch = id => request({
  url: `/branches/${id}`,
  method: 'delete'
});
export const createBranch = data => request({
  url: '/branches',
  method: 'post',
  data
});